export const genericLiquidateFooterParser = portfolio => {
  return [
    {
      type: 'confirmationOfPurchaseUrl',
      title: 'Confirmation Of Purchase',
      val: portfolio?.confirmationOfPurchaseUrl,
    },
    {
      type: 'securitiesTransferFormUrl',
      title: 'Securities Transfer Form',
      val: portfolio?.securitiesTransferFormUrl,
    },
    {
      type: 'securitiesTransferFormSignUrl',
      title: 'Sign Securities Transfer Form',
      val: portfolio?.state === 'owner_sign_pending' && portfolio?.securitiesTransferFormSignUrl,
      primary: true,
    },
  ]
}

export const liquidateFooterParser = portfolio => {
  return genericLiquidateFooterParser(portfolio)
}
